export function cacheDetachBenefitFromTier(client, params) {
    const { tierId, benefitId, typename } = params;
    client.cache.modify({
        id: `MembershipTier:${tierId}`,
        fields: {
            benefits(existing = [], { readField }) {
                const list = Array.isArray(existing) ? existing.filter(Boolean) : [];
                return list.filter((ref) => {
                    const id = readField('id', ref);
                    return id !== benefitId;
                });
            },
            subscriptionBenefit(existing = null) {
                return (typename === 'SubscriptionBenefit') ? null : existing;
            },
            welcomeGift(existing = null) {
                return (typename === 'WelcomeGiftBenefit') ? null : existing;
            },
            redemptionBenefit(existing = null) {
                return (typename === 'RedemptionBenefit') ? null : existing;
            },
        }
    });
}
